// components/support/TicketCard.jsx
import { useTranslation } from "react-i18next"; // ← اضافه شده
import { Link } from "react-router-dom";

const TicketCard = ({ ticket }) => {
  const { t } = useTranslation(); // ← اضافه شده
  const statusColors = {
    open: "text-yellow-600",
    answered: "text-green-600",
    closed: "text-gray-500",
  };

  const getStatusText = (status) => {
    switch (status) {
      case "open":
        return t("ticket_card.status_open");
      case "answered":
        return t("ticket_card.status_answered");
      case "closed":
        return t("ticket_card.status_closed");
      default:
        return status;
    }
  };

  return (
    <Link
      to={"/support/" + ticket?._id}
      className="bg-white shadow rounded-lg p-4 block hover:bg-white/50"
    >
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-semibold text-gray-800">{ticket.subject}</h3>
        <span className={`text-xs font-medium ${statusColors[ticket.status]}`}>
          {getStatusText(ticket.status)}
        </span>
      </div>
      <p className="text-sm text-gray-600">
        {t("ticket_card.date")}: {ticket.createdAt}
      </p>
    </Link>
  );
};

export default TicketCard;
